import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';

export class VoiceConvLog extends Component {
    constructor() {
        super();
        this.state = {
            utData: []
        }
    }

    componentDidMount() {
        var thisController = this;
        window.getConvLogTimeoutHandle = setInterval(function () {
            thisController.fetchConversationLogApi();
        }, 5000);
    }

    componentWillUnmount() {
        clearTimeout(window.getConvLogTimeoutHandle);
    }

    fetchConversationLogApi = () => {
        var callId = localStorage.getItem("callId");
        if (callId == null || callId == undefined) {
            this.state.utData = this.state.utData;
        } else {
            this.fetchConversationsApi(callId);
        }
        this.setState(this.state);
    }

    fetchConversationsApi = (callId) => {
        var testVoiceComponent = this;
        $.ajax({
            url: "/api/voice-conversations",
            async: false,
            method: 'GET',
            data: {
                "callId": callId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    testVoiceComponent.state.utData = res.result;
                    testVoiceComponent.setState(testVoiceComponent.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    render() {
        const columns1 = [
            {
                Header: '',
                minWidth: 17,
                textAlign: 'screenLeft',
                accessor: 'text',
                sortable: false,
                cellStyle: { border: 'none' },
                headerStyle: { marginTop: '-10px' },
                Cell: props =>
                (
                    <div class="card-body chat_body log_one" style={{ display: props.original.text != "" ? 'block' : 'none' }}>
                        <div className={(props.original.incoming == false) ? "direct-chat-msg" : "direct-chat-msg right "}>
                            <div className={(props.original.incoming == false) ? "direct-chat-text chat_left textarea" : "direct-chat-text chat_right textarea"}
                                style={{
                                    display: props.original.id != "" || props.original.id != undefined ||
                                        props.original.id != null || props.original.text != null ? "block" : "none",
                                    marginTop: "5px", height: "auto",
                                    backgroundColor: props.original.incoming == false ? "#ead5d5" : "#e1e1f5",
                                    marginTop: '-10px', borderBottom: 'none',
                                    textAlign: props.original.incoming == false ? "left" : "right",
                                }}>

                                <font
                                    id={"text" + props.index}
                                    readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}>{props.original.text}
                                </font>
                            </div>
                        </div>
                    </div>
                )
            },
        ]
        return (
            <div>
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link rel="stylesheet" href="./assets/css/react.table.border.css" />
                <div className="col-lg-12" Align='right'>
                    <button className="btn action-button"
                        style={{ marginTop: '-15px' }}
                        onClick={this.fetchConversationLogApi}
                        title="Refresh">
                        <img src="./assets/images/refresh_white_24dp.png" />
                    </button>
                </div>
                <div className="card-body p-0">
                    <div class="table-responsive logTableBox">
                        <ReactTable id='reactTable'
                            data={this.state.utData}
                            columns={columns1}
                            showPagination={false}
                            pageSize={this.state.utData.length <= 5 ? 5 : this.state.utData.length}
                        />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/VoiceConvLog.js